import * as types from "../constants/constants";

let initialState = {
  data: [],
  permissions: [],
  error: "",
  message: "",
  role: "",
  role_id: "",
  role_type: "",
  isAuthenticated: false,
  loading: false,

  verifying: false,
  verifyError: "",
  verifiedData: null,

  otpVerifying: false,
  otpVerified: null,
  otpError: null,

  resettingPassword: false,
  resetPasswordResult: null,
  resetPasswordError: null,
};

function overRidePermissions(data) {
  console.log("data::::::::::::::::::::::::::::", data)
  let permission = [];
  if (data?.permissions?.length)
    data.permissions.map((e) =>
      e.permission_id?.frontend_routes?.map((v) => permission.push(v))
    );

  let addonpermission = [
    // '/dashboard',
    "/profile",
    "/profile/edit",
    "/profile/password",
    "/profile/bankdetails",
  ];
  addonpermission.map((e) => permission.push(e));

  if (data?.role_id?.type === "admin") return [];
  return permission;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_DATA:
      return {
        ...state,
        error: "",
        message: "",
        isAuthenticated: false,
        loading: true,
      };
    case types.LOGIN_DATA_SUCCESS:
      return {
        ...state,
        data: action.data.data,
        role: action.data.data.user.role,
        role_type: action.data.data.user.role_type,
        // role_id: action?.data?.data?.user?.role_id || '',
        // permissions: overRidePermissions(action.data.data.user),
        permissions: action?.data?.data?.user?.school_role_id?.permissions,
        // error: "",
        token: action.data.token,
        message: action.data.message,
        isAuthenticated: true,
        loading: false,
      };
    case types.LOGIN_DATA_FAIL:
      return {
        ...state,
        data: [],
        error: action.data,
        message: "",
        isAuthenticated: false,
        loading: false,
      };
    case types.LOGIN_DATA_CLEAR:
      return {
        ...state,
        data: [],
        error: "",
        message: "",
        isAuthenticated: false,
        loading: false,
      };
    case types.LOGIN_DATA_OVERRIDE:
      return {
        ...state,
        data: { user: action.data },
        role: action.data.role,
        role_id: action?.data?.role_id || "",
        permissions: action?.data?.school_role_id?.permissions,
      };

    case types.SIGNUP_DATA:
      return {
        ...state,
        error: "",
        message: "",
        isAuthenticated: false,
        loading: true,
      };
    case types.SIGNUP_DATA_SUCCESS:
      return {
        ...state,
        data: action.data.data, // Assuming API response has a 'data' field
        message: action.data.message,
        isAuthenticated: true, // Set to true if signup auto-authenticates the user
        loading: false,
      };
    case types.SIGNUP_DATA_FAIL:
      return {
        ...state,
        data: [],
        error: action.data,
        message: "",
        isAuthenticated: false,
        loading: false,
      };
    case types.SIGNUP_DATA_CLEAR:
      return {
        ...state,
        data: [],
        error: "",
        message: "",
        isAuthenticated: false,
        loading: false,
      };
    case types.VERIFY_EMAIL_INIT:
      return {
        ...state,
        verifying: true,
        verifyError: "",
      };
    case types.VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        verifying: false,
        verifiedData: action.payload,
        message: action.payload.message || "Email verification successful",
      };
    case types.VERIFY_EMAIL_FAIL:
      return {
        ...state,
        data: [],
        error: action.data,
        message: "",
        isAuthenticated: false,
        loading: false,
      };

    // otp verify
    case types.OTP_VERIFY_INIT:
      return {
        ...state,
        otpVerifying: true,
        otpError: null,
      };
    case types.OTP_VERIFY_SUCCESS:
      return {
        ...state,
        otpVerifying: false,
        otpVerified: action.payload,
        message: action.payload.message || "OTP verification successful",
      };
    case types.OTP_VERIFY_FAIL:
      return {
        ...state,
        otpVerifying: false,
        otpError: action.payload,
      };

    // reset password
    case types.RESET_PASSWORD_INIT:
      return {
        ...state,
        resettingPassword: true,
        resetPasswordError: null,
      };
    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resettingPassword: false,
        resetPasswordResult: action.payload,
      };
    case types.RESET_PASSWORD_FAIL:
      return {
        ...state,
        resettingPassword: false,
        resetPasswordError: action.payload,
      };

    default:
      return state;
  }
};
